import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { GeneralPaymentService } from 'src/app/services/GeneralPayment/general-payment.service';

@Component({
  selector: 'app-general-payment-receipt-print',
  templateUrl: './general-payment-receipt-print.component.html',
  styleUrls: ['./general-payment-receipt-print.component.css']
})
export class GeneralPaymentReceiptPrintComponent implements OnInit {

  PrintModel = {
    ReceiptNo: "0",
    PrintType:"",
    CopyType:""
  }
  DisplayModel = {
    ClassName: '',
    PaymentDate: '',
    GRNo:'',
    Name:'',
    PaymentMode:'',
    SectionName:'',
    ChequeNo:'',
    BankName:'',
    ParentID:'',
    TotalPaidAmount:0,
  }

  BranchDetails: any;
  GeneralPaymentList: any=[];
  ReceiptList:any=[];
  Integer: any;
  decimal: any;
  itemsPerPage = 10;
  pagedItems = [];

  constructor(private activatedRoute: ActivatedRoute, private generalpaymentService: GeneralPaymentService,
    private spinnerService: Ng4LoadingSpinnerService, public globalHelper: GlobalHelper) {
    this.activatedRoute.queryParams.subscribe(params => {
      this.PrintModel.ReceiptNo = params['ReceiptNo'];
      this.PrintModel.CopyType = params['CopyType'];
      this.PrintModel.PrintType = params['PrintType'];
      this.GetGeneralPaymentReceipt();
    });
    
  }
 
  GetGeneralPaymentReceipt() {
    this.spinnerService.show()
    this.generalpaymentService.GetGeneralPaymentReceipt(this.PrintModel.ReceiptNo).subscribe((response) => {
      this.BranchDetails = response.BranchDetails;      
      this.spinnerService.hide()
      this.GeneralPaymentList = response.GeneralPaymentList;
      if (this.GeneralPaymentList != null && this.GeneralPaymentList.length > 0) {
        this.DisplayModel.ClassName=this.GeneralPaymentList[0].ClassName;
        this.DisplayModel.PaymentDate=this.GeneralPaymentList[0].PaymentDate;
        this.DisplayModel.GRNo=this.GeneralPaymentList[0].GRNo;
        this.DisplayModel.Name=this.GeneralPaymentList[0].Name;       
        this.DisplayModel.PaymentMode=this.GeneralPaymentList[0].PaymentMode;
        this.DisplayModel.ClassName=this.GeneralPaymentList[0].ClassName;
        this.DisplayModel.SectionName=this.GeneralPaymentList[0].SectionName;
        this.DisplayModel.ChequeNo=this.GeneralPaymentList[0].ChequeNo;
        this.DisplayModel.BankName=this.GeneralPaymentList[0].BankName;
        this.DisplayModel.ParentID=this.GeneralPaymentList[0].ParentID;
        var TotalPaidAmount=0;
        for (var i = 0; i < this.GeneralPaymentList.length; i++) {
          TotalPaidAmount = TotalPaidAmount + this.GeneralPaymentList[i].PaidAmount;
      }
      this.DisplayModel.TotalPaidAmount = TotalPaidAmount;
      var str = (Math.round(this.DisplayModel.TotalPaidAmount * 1000) / 1000).toString().trim();
      var substr = str.split('.');
      this.Integer = substr[0];
      this.decimal = (substr.length == 2 ? substr[1] : 0);
      // this.search(this.GeneralPaymentList);
        this.spinnerService.hide()
        setTimeout(function () {
          window.print();
        }, 300);
      }


    });
  };


  search(itemlist) {

    for (var i = 0; i < itemlist.length; i++) {
      if (i % this.itemsPerPage === 0) {
        this.pagedItems[Math.floor(i / this.itemsPerPage)] = [itemlist[i]];
      } else {
        this.pagedItems[Math.floor(i / this.itemsPerPage)].push(itemlist[i]);
      }
    }

  }

  ngOnInit() {
  }

}


